export const styles = {
    linearProgress: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 10000
    }
};
